import { render, staticRenderFns } from "./PageUnderConstruction.vue?vue&type=template&id=0f788a91&"
import script from "./PageUnderConstruction.vue?vue&type=script&lang=js&"
export * from "./PageUnderConstruction.vue?vue&type=script&lang=js&"
import style0 from "./PageUnderConstruction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports